// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/Preferences.scss
// module id = ./src/styles/Preferences.scss
// module chunks = 0